module.exports = __webpack_public_path__ + "static/media/bg-chat-tile-dark.a4be512e.png";